// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Login.js
SignUp.js
SignupBusiness.js
*/

.login-form,
.signup-form,
.signupbusiness-form {
  font-family: 'Helvetica' ;
}

/* Mobile */
@media only screen and (max-width: 679px) {
  .logo-logo {
    padding-top: 40px;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 10px;
  }
}

/* Desktop*/
@media only screen and (min-width: 680px) {
  .logo-logo {
    padding-top: 13px;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 10px;
  }
}

form.signal34-form {
  width: 70% ;
  padding-bottom: 15px;
  min-width: 260px ;
}

.signal34-form .form-group-lg,
.signal34-form .form-control {
  height: 41px ;
  margin-bottom: 9px;
}

.signal34-form input::placeholder {
  color: #C2C2C2;
}

.signal34-form input[type="password"],
.signal34-form input[type="email"] {
  border: 2px solid #C6C6C6;
  font-size: 12pt;
  padding-left: 14px;
  padding-right: 12px;
  padding-top: 0px;
  padding-bottom: 0px;
  color: var(--signal34FormInputTextColor);
}

.signal34-blue-button .signal34-bnt-primary {
  height: 38px ;
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: 12.2pt;
  width: 100%;
  cursor: pointer;
}

.signal34-continuing {
  font-size: 8.8pt;
  color: #CCCCCC;
  text-align: center;
}

.signal34-continuing span {
  font-size: 8.8pt;
  color: #4571A8;
}

.signal34-continuing span a {
  font-size: 8.8pt;
  color: #4571A8 ;
  text-decoration: none;
}

.signal34-logo {
  position: relative;
  width: calc(min-content - 4);
  display: table-cell;
}

.signal34-logo-confirm {
  display: block;
  width: 4%;
  margin-left: auto;
  margin-right: auto;
}

.signal34-logo .logo {
  padding-left: 8px;
  padding-right: 8px;
}

/*
Login.js
SignUp.js
*/
.signal34-or {
  font-size: 9.1pt;
  color: var(--primaryTextColor);
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}

.signal34-facebook {
  background-color: #4267B2;
  color: white;
  height: 41px ;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 7px;
  padding-right: 7px;
  border-radius: 4px;
  width: 100%;
  display: table;
  cursor: pointer;
}

.signal34-google {
  background-color: #4285F4;
  color: white;
  height: 41px ;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 7px;
  padding-right: 7px;
  border-radius: 4px;
  margin-top: 9px ;
  width: 100%;
  display: table;
  cursor: pointer;
}

.signup-form .signal34-logo,
.login-form .signal34-logo {
  padding-top: 1px;
  padding-bottom: 6px;
  padding-left: 12px;
  padding-right: 12px;
  text-align: center;
  display: inline-block;
}
.svg-container {
  width: 33px ;
  height: 41px ;
}
div.signal34-explore+p {
  height: 16px ;
}
/*
Signup.js
SignunBusiness.js
*/
.signal34-middle-bold {
  padding-top: 20px;
  display: table;
  text-align: center;
}

.sigunpbusiness-recaptcha,
.sigunp-recaptcha {
  -moz-transform: scale(0.874, 1.0);
  -moz-transform-origin: 0 0;
  transform: scale(0.874, 1.0);
  transform-origin: 0 0;
}

@media only screen and (max-width: 410px) {

  .sigunpbusiness-recaptcha,
  .sigunp-recaptcha {
    -moz-transform: scale(0.854, 1.0);
    -moz-transform-origin: 0 0;
    transform: scale(0.854, 1.0);
    transform-origin: 0 0;
    min-width: 310px ;
  }
}

.signal34-middle-bold.create-personal {
  margin-top: 44px;
  margin-bottom: 16px;
  display: inline-block;
}

.signal34-middle-bold a {
  display: inline-flex;
  text-align: center;
  vertical-align: middle;
}

.signal34-middle-bold a:link {
  text-decoration: none;
}

.center-text-signup {
  text-align: center;
}

/*
Login.js
*/
.login-form .signal34-form {
  padding-bottom: 15px;
  width: 70% ;
  text-align: center;
  display: inline-block;
  min-width: 260px ;
}

.login-form .form-group {
  margin-bottom: 15px;
}

.signal34-grow {
  font-family: "Helvetica-Bold" ;
  font-size: 13.5pt;
  color: #D7D7D7;
  padding-bottom: 32px;
  padding-top: 2px;
}

.signal34-explore {
  font-size: 12pt;
  color: #6C6C6C;
  text-align: center;
  line-height: 1.20355555;
}

.signal34-confirm-text {
  font-size: 24pt;
  color: #6C6C6C;
  text-align: center;
  line-height: 1.20355555;
}

.signal34-confirm-error {
  font-size: 20pt;
  color: #6C6C6C;
  text-align: center;
  line-height: 1.20355555;
}

.login-form .signal34-blue-button {
  margin-top: 26px ;
  color: white;
  cursor: pointer;
}

.login-form .signal34-footer {
  font-size: 8.8pt;
  position: relative;
  bottom: 0;
  display: block;
  width: 100%;
  padding-bottom: 15px;
  padding-top: 46px;
}

div.signal34-gray-button {
  background-color: #EFEFEF;
  color: #3F3F3F;
  height: 38px ;
  width: 100%;
  border-radius: 6px;
  font-size: 12.2pt;
  display: table;
  cursor: pointer;
}

.signal34-gray-button button {
  color: #3F3F3F;
  background-color: #EFEFEF;
  display: inline-block;
  padding-top: 6px;
  width: 100%;
  border-color: #EFEFEF;
  font-size: 12.2pt;
  cursor: pointer;
}

div.signal34-gray-button,
.signal34-gray-button button:hover,
.signal34-gray-button button:focus,
.signal34-gray-button button:active:focus
{
  color: #3F3F3F;
  text-decoration: none;
  cursor: pointer;
  background-color:#e6e6e6;
  border-color:#adadad;
}

.signal34-gray-button a {
  color: #3F3F3F;
  display: inline-block;
  padding-top: 6px;
}

.signal34-gray-button a:link {
  text-decoration: none;
}

.signal34-google span+img,
.signal34-facebook span+img {
  float: left;
  width: 24px ;
  height: 24px ;
  display: inline-block;
  vertical-align: middle;
  margin-top: 8px;
}

.signal34-google span,
.signal34-facebook span {
  font-size: 12.2pt;
  display: table-cell;
  padding-top: 8px;
}

.signal34-forgot {
  font-size: 9.4pt;
  padding-top: 16px;
  color: #4571A8 ;
}

.signal34-forgot a {
  color: #4571A8 ;
  font-weight: bold;
  font-size: 9.4pt;
}

.signal34-forgot svg {
  width: 70% ;
  padding-top: 8px;
  padding-bottom: 8px;
}

.rc-anchor-center-container {
  max-width: 122px ;
  width: 122px ;
}

/*
SignUp.js
*/
.signup-form .logo-logo {
  padding-top: 12px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 5px;
}

.signup-form .signal34-form {
  width: 70% ;
  padding-top: 13px;
  padding-bottom: 15px;
}

.signup-form .Login {
  padding-top: 60px;
  padding-bottom: 20px;
}

@media only screen and (max-width: 410px) {
  .signup-form .Login {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

.signup-form .form-group {
  margin-bottom: 15spx;
}

.signup-form .signal34-recaptcha {
  height: 90px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.signup-form .signal34-blue-button {
  margin-top: 19px ;
  color: white;
}

.signup-form .help-block {
  margin: 0px ;
}

.signup-form .signal34-middle-bold {
  padding-top: 14px;
  display: table;
}

.signup-form .signal34-middle-bold a {
  font-size: 12.2pt;
  padding-bottom: 10px;
  color: black;
  margin-top: 0px;
}

.signal34-already {
  display: inherit;
  padding-top: 30px;
  text-align: center;
}

.signal34-already span {
  font-size: 8.7pt;
  color: #4571A8;
  width: 70%;
  padding-bottom: 14px;
  float: left;
  display: inline;
}

.signal34-already a {
  font-weight: bold;
  font-size: 8.7pt;
  color: #4571A8;
}

.signal34-signup {
  display: inline-block;
  text-align: left;
  width: 70%;
  min-width: 260px ;
}

.signal34-signup span {
  font-size: 8.7pt;
  color: #4571A8;
  width: 70%;
  padding-bottom: 15px;
  float: left;
  display: inline;
}

.signal34-signup a {
  font-weight: bold;
  font-size: 8.7pt;
  color: #4571A8;
}

/*
SignupBusiness.js
*/
.signupbusiness-form .logo-logo {
  padding-top: 11px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 9px;
}

.signal34-welcome {
  text-shadow: 1px 0px #3F3F3F;
  font-size: 21pt;
  color: #3F3F3F;
  line-height: 1.1;
}

.signal34-confirm {
  text-shadow: 1px 0px #3F3F3F;
  font-size: 55pt;
  color: #3F3F3F;
  line-height: 1.1;
}

.signupbusiness-form {
  padding-bottom: 14px;
}

.signupbusiness-form form.signal34-form {
  width: 70% ;
  padding-top: 12px;
}

.signupbusiness-form .signal34-recaptcha {  
  padding-top: 15px;
}

.signupbusiness-form .signup-recaptcha {
  width: 70% ;
  height: 108px ;
}

.signupbusiness-form .rc-anchor-center-container .rc-anchor-checkbox-label {
  font-size: 16px ;
  letter-spacing: 2px ;
  font-weight: bold;
}

.signupbusiness-form .signal34-blue-button {
  margin-top: 10px ;
  color: white;
}

.signal34-ten {
  height: 14px ;
}

.signupbusiness-form .signal34-middle-bold {
  padding-top: 0px;
  margin-bottom: 0px ;
  display: inline-block;
  text-align: center;
}

.signupbusiness-form .signal34-middle-bold.create-personal {
  margin-top: 51px;
  display: inline-block;
}

.signupbusiness-form .signal34-middle-bold a {
  font-size: 12.2pt;
  padding-bottom: 10px;
  color: black;
  margin-top: 12px;
}

div.create-personal {
  width: 100% ;
  height: 50px ;
  background-color: #EFEFEF;
  border-radius: 0px 0px 4px 4px;
  color: #333333 ;
  display: table;
}

div.create-business {
  width: 100% ;
  height: 61px ;
  background-color: #EFEFEF;
  border-radius: 0px 0px 4px 4px;
  color: #333333 ;
  display: table;
}

.signal34-middle-bold.create-business span,
.signal34-middle-bold.create-personal span {
  padding-bottom: 0px;
  text-shadow: 0 0 2px #d3d3d3;
}

.signupbusiness-form .signal34-logo {
  padding-top: 1px;
  padding-bottom: 3px;
  padding-left: 12px;
  padding-right: 12px;
  text-align: center;
  display: inline-block;
}

.signupbusiness-form .signal34-footer {
  font-size: 8.8pt;
  text-overflow: ellipsis;
  position: relative;
  bottom: 0;
  display: block;
  width: 100%;
  padding-bottom: 15px;
  padding-top: 14px;
}

.signupbusiness-form .form-group {
  margin-bottom: 15px;
}

/*
 ForgotPassword.js
 */
.Login {
  padding-top: 30px;
  padding-bottom: 0;
}

.Login form {
  margin: 0 auto;
  max-width: 320px;
}

.Login div.card {
  margin: 0 auto;
  max-width: 380px;
  display: inherit;
}

.Login div.card-confirm {
  margin: 0 auto;
  max-width: 380px;
  display: inherit;
}

.Login .card {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
}

@media only screen and (max-width: 410px) {
  .Login {
    padding-top: 0;
    padding-bottom: 0;
  }

  .Login form {
    margin: 0 auto;
    max-width: 320px;
  }

  .Login div.card {
    margin: unset;
    max-width: 380px;
    display: inherit;
  }
}

/*
 ForgotPassword.js
 Login.js
 ResetPassword.js
 Signup.js
 SignupBusiness.js
 */

 .Forgot form {
    margin: 0 auto;
    max-width: 320px;
    padding: 10px;
 }

.card {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
  background: #ffffff;
  border-radius: 5px;
  color: #123;
  display: flex;
  flex-direction: column;
}

.card p {
  height: 12px;
}

/*
ForgotPassword.js
ResetPassword.js
*/
.center-text-login {
  text-align: center;
  font-size: 22px;
  color: #98a09e;
  padding: 20px;
}

.center-text-login p {
  text-align: center;
  font-size: 22px;
  color: #98a09e;
}

/* Login dialog */
.login-dialog-modal-body {
  position: absolute;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 0px;
}

.login-dialog-header {
  border-bottom: 0px transparent;
  z-index: 100;
}

.login-dialog-header .btn-close {
  padding: 5px;
}

.login-dialog-modal .modal-dialog{
  max-width: 380px;
  padding: 0px;
  margin: 30px auto;
}

/* Login card */
.login-card {
  padding-bottom: 0;
  padding-top: 30px;
}

.login-card form {
  margin: 0 auto;
  max-width: 320px;
}

.login-card div.card {
  margin: 0 auto;
  max-width: 380px;
  display: inherit;
}

.login-dialog-modal-body .card {
  box-shadow: 0 0 0 transparent;
  border: 0px transparent;
}

@media only screen and (max-width: 410px) {
  .login-card {
    padding-top: 0;
    padding-bottom: 0;
  }

  .login-card form {
    margin: 0 auto;
    max-width: 320px;
  }

  .login-card div.card {
    margin: unset;
    max-width: 380px;
    display: inherit;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;;;EAGE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA,WAAW;AACX;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;CAGC;AACD;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;;CAGC;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;EAEE;;IAEE,iCAAiC;IACjC,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;IACrB,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;CAEC;AACD;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;EAKE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;;CAEC;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;CAEC;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE;AACF;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;;;;;;EAME;;CAED;IACG,cAAc;IACd,gBAAgB;IAChB,aAAa;CAChB;;AAED;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;;;CAGC;AACD;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["/*\nLogin.js\nSignUp.js\nSignupBusiness.js\n*/\n\n.login-form,\n.signup-form,\n.signupbusiness-form {\n  font-family: 'Helvetica' ;\n}\n\n/* Mobile */\n@media only screen and (max-width: 679px) {\n  .logo-logo {\n    padding-top: 40px;\n    padding-left: 15px;\n    padding-right: 15px;\n    padding-bottom: 10px;\n  }\n}\n\n/* Desktop*/\n@media only screen and (min-width: 680px) {\n  .logo-logo {\n    padding-top: 13px;\n    padding-left: 15px;\n    padding-right: 15px;\n    padding-bottom: 10px;\n  }\n}\n\nform.signal34-form {\n  width: 70% ;\n  padding-bottom: 15px;\n  min-width: 260px ;\n}\n\n.signal34-form .form-group-lg,\n.signal34-form .form-control {\n  height: 41px ;\n  margin-bottom: 9px;\n}\n\n.signal34-form input::placeholder {\n  color: #C2C2C2;\n}\n\n.signal34-form input[type=\"password\"],\n.signal34-form input[type=\"email\"] {\n  border: 2px solid #C6C6C6;\n  font-size: 12pt;\n  padding-left: 14px;\n  padding-right: 12px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  color: var(--signal34FormInputTextColor);\n}\n\n.signal34-blue-button .signal34-bnt-primary {\n  height: 38px ;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  font-size: 12.2pt;\n  width: 100%;\n  cursor: pointer;\n}\n\n.signal34-continuing {\n  font-size: 8.8pt;\n  color: #CCCCCC;\n  text-align: center;\n}\n\n.signal34-continuing span {\n  font-size: 8.8pt;\n  color: #4571A8;\n}\n\n.signal34-continuing span a {\n  font-size: 8.8pt;\n  color: #4571A8 ;\n  text-decoration: none;\n}\n\n.signal34-logo {\n  position: relative;\n  width: calc(min-content - 4);\n  display: table-cell;\n}\n\n.signal34-logo-confirm {\n  display: block;\n  width: 4%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.signal34-logo .logo {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n/*\nLogin.js\nSignUp.js\n*/\n.signal34-or {\n  font-size: 9.1pt;\n  color: var(--primaryTextColor);\n  padding-top: 10px;\n  padding-bottom: 10px;\n  text-align: center;\n}\n\n.signal34-facebook {\n  background-color: #4267B2;\n  color: white;\n  height: 41px ;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: 7px;\n  padding-right: 7px;\n  border-radius: 4px;\n  width: 100%;\n  display: table;\n  cursor: pointer;\n}\n\n.signal34-google {\n  background-color: #4285F4;\n  color: white;\n  height: 41px ;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: 7px;\n  padding-right: 7px;\n  border-radius: 4px;\n  margin-top: 9px ;\n  width: 100%;\n  display: table;\n  cursor: pointer;\n}\n\n.signup-form .signal34-logo,\n.login-form .signal34-logo {\n  padding-top: 1px;\n  padding-bottom: 6px;\n  padding-left: 12px;\n  padding-right: 12px;\n  text-align: center;\n  display: inline-block;\n}\n.svg-container {\n  width: 33px ;\n  height: 41px ;\n}\ndiv.signal34-explore+p {\n  height: 16px ;\n}\n/*\nSignup.js\nSignunBusiness.js\n*/\n.signal34-middle-bold {\n  padding-top: 20px;\n  display: table;\n  text-align: center;\n}\n\n.sigunpbusiness-recaptcha,\n.sigunp-recaptcha {\n  -moz-transform: scale(0.874, 1.0);\n  -moz-transform-origin: 0 0;\n  transform: scale(0.874, 1.0);\n  transform-origin: 0 0;\n}\n\n@media only screen and (max-width: 410px) {\n\n  .sigunpbusiness-recaptcha,\n  .sigunp-recaptcha {\n    -moz-transform: scale(0.854, 1.0);\n    -moz-transform-origin: 0 0;\n    transform: scale(0.854, 1.0);\n    transform-origin: 0 0;\n    min-width: 310px ;\n  }\n}\n\n.signal34-middle-bold.create-personal {\n  margin-top: 44px;\n  margin-bottom: 16px;\n  display: inline-block;\n}\n\n.signal34-middle-bold a {\n  display: inline-flex;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.signal34-middle-bold a:link {\n  text-decoration: none;\n}\n\n.center-text-signup {\n  text-align: center;\n}\n\n/*\nLogin.js\n*/\n.login-form .signal34-form {\n  padding-bottom: 15px;\n  width: 70% ;\n  text-align: center;\n  display: inline-block;\n  min-width: 260px ;\n}\n\n.login-form .form-group {\n  margin-bottom: 15px;\n}\n\n.signal34-grow {\n  font-family: \"Helvetica-Bold\" ;\n  font-size: 13.5pt;\n  color: #D7D7D7;\n  padding-bottom: 32px;\n  padding-top: 2px;\n}\n\n.signal34-explore {\n  font-size: 12pt;\n  color: #6C6C6C;\n  text-align: center;\n  line-height: 1.20355555;\n}\n\n.signal34-confirm-text {\n  font-size: 24pt;\n  color: #6C6C6C;\n  text-align: center;\n  line-height: 1.20355555;\n}\n\n.signal34-confirm-error {\n  font-size: 20pt;\n  color: #6C6C6C;\n  text-align: center;\n  line-height: 1.20355555;\n}\n\n.login-form .signal34-blue-button {\n  margin-top: 26px ;\n  color: white;\n  cursor: pointer;\n}\n\n.login-form .signal34-footer {\n  font-size: 8.8pt;\n  position: relative;\n  bottom: 0;\n  display: block;\n  width: 100%;\n  padding-bottom: 15px;\n  padding-top: 46px;\n}\n\ndiv.signal34-gray-button {\n  background-color: #EFEFEF;\n  color: #3F3F3F;\n  height: 38px ;\n  width: 100%;\n  border-radius: 6px;\n  font-size: 12.2pt;\n  display: table;\n  cursor: pointer;\n}\n\n.signal34-gray-button button {\n  color: #3F3F3F;\n  background-color: #EFEFEF;\n  display: inline-block;\n  padding-top: 6px;\n  width: 100%;\n  border-color: #EFEFEF;\n  font-size: 12.2pt;\n  cursor: pointer;\n}\n\ndiv.signal34-gray-button,\n.signal34-gray-button button:hover,\n.signal34-gray-button button:focus,\n.signal34-gray-button button:active:focus\n{\n  color: #3F3F3F;\n  text-decoration: none;\n  cursor: pointer;\n  background-color:#e6e6e6;\n  border-color:#adadad;\n}\n\n.signal34-gray-button a {\n  color: #3F3F3F;\n  display: inline-block;\n  padding-top: 6px;\n}\n\n.signal34-gray-button a:link {\n  text-decoration: none;\n}\n\n.signal34-google span+img,\n.signal34-facebook span+img {\n  float: left;\n  width: 24px ;\n  height: 24px ;\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 8px;\n}\n\n.signal34-google span,\n.signal34-facebook span {\n  font-size: 12.2pt;\n  display: table-cell;\n  padding-top: 8px;\n}\n\n.signal34-forgot {\n  font-size: 9.4pt;\n  padding-top: 16px;\n  color: #4571A8 ;\n}\n\n.signal34-forgot a {\n  color: #4571A8 ;\n  font-weight: bold;\n  font-size: 9.4pt;\n}\n\n.signal34-forgot svg {\n  width: 70% ;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.rc-anchor-center-container {\n  max-width: 122px ;\n  width: 122px ;\n}\n\n/*\nSignUp.js\n*/\n.signup-form .logo-logo {\n  padding-top: 12px;\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-bottom: 5px;\n}\n\n.signup-form .signal34-form {\n  width: 70% ;\n  padding-top: 13px;\n  padding-bottom: 15px;\n}\n\n.signup-form .Login {\n  padding-top: 60px;\n  padding-bottom: 20px;\n}\n\n@media only screen and (max-width: 410px) {\n  .signup-form .Login {\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n}\n\n.signup-form .form-group {\n  margin-bottom: 15spx;\n}\n\n.signup-form .signal34-recaptcha {\n  height: 90px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.signup-form .signal34-blue-button {\n  margin-top: 19px ;\n  color: white;\n}\n\n.signup-form .help-block {\n  margin: 0px ;\n}\n\n.signup-form .signal34-middle-bold {\n  padding-top: 14px;\n  display: table;\n}\n\n.signup-form .signal34-middle-bold a {\n  font-size: 12.2pt;\n  padding-bottom: 10px;\n  color: black;\n  margin-top: 0px;\n}\n\n.signal34-already {\n  display: inherit;\n  padding-top: 30px;\n  text-align: center;\n}\n\n.signal34-already span {\n  font-size: 8.7pt;\n  color: #4571A8;\n  width: 70%;\n  padding-bottom: 14px;\n  float: left;\n  display: inline;\n}\n\n.signal34-already a {\n  font-weight: bold;\n  font-size: 8.7pt;\n  color: #4571A8;\n}\n\n.signal34-signup {\n  display: inline-block;\n  text-align: left;\n  width: 70%;\n  min-width: 260px ;\n}\n\n.signal34-signup span {\n  font-size: 8.7pt;\n  color: #4571A8;\n  width: 70%;\n  padding-bottom: 15px;\n  float: left;\n  display: inline;\n}\n\n.signal34-signup a {\n  font-weight: bold;\n  font-size: 8.7pt;\n  color: #4571A8;\n}\n\n/*\nSignupBusiness.js\n*/\n.signupbusiness-form .logo-logo {\n  padding-top: 11px;\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-bottom: 9px;\n}\n\n.signal34-welcome {\n  text-shadow: 1px 0px #3F3F3F;\n  font-size: 21pt;\n  color: #3F3F3F;\n  line-height: 1.1;\n}\n\n.signal34-confirm {\n  text-shadow: 1px 0px #3F3F3F;\n  font-size: 55pt;\n  color: #3F3F3F;\n  line-height: 1.1;\n}\n\n.signupbusiness-form {\n  padding-bottom: 14px;\n}\n\n.signupbusiness-form form.signal34-form {\n  width: 70% ;\n  padding-top: 12px;\n}\n\n.signupbusiness-form .signal34-recaptcha {  \n  padding-top: 15px;\n}\n\n.signupbusiness-form .signup-recaptcha {\n  width: 70% ;\n  height: 108px ;\n}\n\n.signupbusiness-form .rc-anchor-center-container .rc-anchor-checkbox-label {\n  font-size: 16px ;\n  letter-spacing: 2px ;\n  font-weight: bold;\n}\n\n.signupbusiness-form .signal34-blue-button {\n  margin-top: 10px ;\n  color: white;\n}\n\n.signal34-ten {\n  height: 14px ;\n}\n\n.signupbusiness-form .signal34-middle-bold {\n  padding-top: 0px;\n  margin-bottom: 0px ;\n  display: inline-block;\n  text-align: center;\n}\n\n.signupbusiness-form .signal34-middle-bold.create-personal {\n  margin-top: 51px;\n  display: inline-block;\n}\n\n.signupbusiness-form .signal34-middle-bold a {\n  font-size: 12.2pt;\n  padding-bottom: 10px;\n  color: black;\n  margin-top: 12px;\n}\n\ndiv.create-personal {\n  width: 100% ;\n  height: 50px ;\n  background-color: #EFEFEF;\n  border-radius: 0px 0px 4px 4px;\n  color: #333333 ;\n  display: table;\n}\n\ndiv.create-business {\n  width: 100% ;\n  height: 61px ;\n  background-color: #EFEFEF;\n  border-radius: 0px 0px 4px 4px;\n  color: #333333 ;\n  display: table;\n}\n\n.signal34-middle-bold.create-business span,\n.signal34-middle-bold.create-personal span {\n  padding-bottom: 0px;\n  text-shadow: 0 0 2px #d3d3d3;\n}\n\n.signupbusiness-form .signal34-logo {\n  padding-top: 1px;\n  padding-bottom: 3px;\n  padding-left: 12px;\n  padding-right: 12px;\n  text-align: center;\n  display: inline-block;\n}\n\n.signupbusiness-form .signal34-footer {\n  font-size: 8.8pt;\n  text-overflow: ellipsis;\n  position: relative;\n  bottom: 0;\n  display: block;\n  width: 100%;\n  padding-bottom: 15px;\n  padding-top: 14px;\n}\n\n.signupbusiness-form .form-group {\n  margin-bottom: 15px;\n}\n\n/*\n ForgotPassword.js\n */\n.Login {\n  padding-top: 30px;\n  padding-bottom: 0;\n}\n\n.Login form {\n  margin: 0 auto;\n  max-width: 320px;\n}\n\n.Login div.card {\n  margin: 0 auto;\n  max-width: 380px;\n  display: inherit;\n}\n\n.Login div.card-confirm {\n  margin: 0 auto;\n  max-width: 380px;\n  display: inherit;\n}\n\n.Login .card {\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);\n}\n\n@media only screen and (max-width: 410px) {\n  .Login {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .Login form {\n    margin: 0 auto;\n    max-width: 320px;\n  }\n\n  .Login div.card {\n    margin: unset;\n    max-width: 380px;\n    display: inherit;\n  }\n}\n\n/*\n ForgotPassword.js\n Login.js\n ResetPassword.js\n Signup.js\n SignupBusiness.js\n */\n\n .Forgot form {\n    margin: 0 auto;\n    max-width: 320px;\n    padding: 10px;\n }\n\n.card {\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);\n  background: #ffffff;\n  border-radius: 5px;\n  color: #123;\n  display: flex;\n  flex-direction: column;\n}\n\n.card p {\n  height: 12px;\n}\n\n/*\nForgotPassword.js\nResetPassword.js\n*/\n.center-text-login {\n  text-align: center;\n  font-size: 22px;\n  color: #98a09e;\n  padding: 20px;\n}\n\n.center-text-login p {\n  text-align: center;\n  font-size: 22px;\n  color: #98a09e;\n}\n\n/* Login dialog */\n.login-dialog-modal-body {\n  position: absolute;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  padding: 0px;\n}\n\n.login-dialog-header {\n  border-bottom: 0px transparent;\n  z-index: 100;\n}\n\n.login-dialog-header .btn-close {\n  padding: 5px;\n}\n\n.login-dialog-modal .modal-dialog{\n  max-width: 380px;\n  padding: 0px;\n  margin: 30px auto;\n}\n\n/* Login card */\n.login-card {\n  padding-bottom: 0;\n  padding-top: 30px;\n}\n\n.login-card form {\n  margin: 0 auto;\n  max-width: 320px;\n}\n\n.login-card div.card {\n  margin: 0 auto;\n  max-width: 380px;\n  display: inherit;\n}\n\n.login-dialog-modal-body .card {\n  box-shadow: 0 0 0 transparent;\n  border: 0px transparent;\n}\n\n@media only screen and (max-width: 410px) {\n  .login-card {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .login-card form {\n    margin: 0 auto;\n    max-width: 320px;\n  }\n\n  .login-card div.card {\n    margin: unset;\n    max-width: 380px;\n    display: inherit;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
